const rawBackendUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
const rawBasename = (process.env.REACT_APP_BASENAME || "").replace(/\/+$/, "");

const appBasePath = rawBasename || "";
const apiRoot = rawBackendUrl
  ? `${rawBackendUrl}/api`
  : `${appBasePath}/index.php?route=/api`;

export const API = apiRoot;
export const APP_BASE_PATH = appBasePath;

export function resolveApiAssetUrl(path) {
  if (!path) {
    return "";
  }

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  if (path.startsWith("/api/")) {
    return rawBackendUrl
      ? `${rawBackendUrl}${path}`
      : `${appBasePath}/index.php?route=${path}`;
  }

  if (path.startsWith("/")) {
    return `${rawBackendUrl}${path}`;
  }

  return `${rawBackendUrl}${appBasePath}/${path.replace(/^\/+/, "")}`;
}
